import { createFileRoute, redirect } from '@tanstack/react-router'

// F-LEGAL-1: /legal (Index) hatte keine Index-Route → leerer Outlet/Content-Kasten.
// Redirect auf den Default-Tab Impressum, damit /legal nie leer rendert und die
// kanonische Content-URL /legal/imprint wiederverwendet wird.
export const Route = createFileRoute('/_auth/legal/')({
  beforeLoad: () => {
    throw redirect({ to: '/legal/imprint' })
  },
})
